// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ga8Gb","type":"styles_type__1RrQH","choices":"styles_choices__22tCD"};